































import Vue from 'vue';
import SectionRow from './SectionRow.vue';
import SectionRowMixin from '@/components/section-row/mixins/SectionRowMixin.vue';
import { CvSectionText } from '@/../gen';

export default Vue.extend({
  components: {
    SectionRow,
  },
  mixins: [SectionRowMixin],
  computed: {
    section(): CvSectionText {
      return this.cvCvSection.section;
    },
    editLink() {
      return {
        name: 'cv_section_texts_edit_path',
        params: { cv_id: this.section.cv_id, id: this.section.id },
      };
    },
  },
});
